import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=8a427244&scoped=true&"
import script from "./NewsCard.vue?vue&type=script&lang=js&"
export * from "./NewsCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsCard.vue?vue&type=style&index=0&id=8a427244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a427244",
  null
  
)

export default component.exports